<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div
    class="input-field"
    :class="{ 'input-field--inline': labelPosition === 'inline' }"
  >
    <label
      v-if="label"
      :for="inputId"
      class="input-field__label"
    >{{ label }}</label>
    <div class="input-field__wrapper">
      <i
        v-if="iconLeft"
        :class="iconLeft"
        class="input-field__icon"
      />
      <input
        :id="inputId"
        ref="input"
        v-maska="{ mask: '+# ### ###-##-##', eager: true }"
        class="app-input"
        type="tel"
        :placeholder="placeholder || '+_ ___ ___-__-__'"
        :disabled="disabled"
        @maska="onMaska"
      />
      <i
        v-if="iconRight"
        :class="iconRight"
        class="input-field__icon"
      />
    </div>
  </div>
</template>

<script>
/**
 * PhoneInput — поле ввода телефона с автоматическим форматированием.
 *
 * Отображает номер в формате: +7 999 999-99-99
 * Возвращает по v-model чистое значение: +79999999999
 *
 * @example Базовый
 * <phone-input v-model="phone" />
 *
 * @example С иконкой и лейблом
 * <phone-input v-model="phone" label="Телефон" icon-left="exu-phone" />
 */
// eslint-disable-next-line import/no-unresolved, import/extensions
import { vMaska } from 'maska/vue';

export default {
  name: 'PhoneInput',
  directives: { maska: vMaska },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    /** 'top' — лейбл над полем, 'inline' — лейбл в строку с полем */
    labelPosition: {
      type: String,
      default: 'top',
      validator: (v) => ['top', 'inline'].includes(v),
    },
    placeholder: {
      type: String,
      default: '',
    },
    /** CSS-класс иконки шрифта, например 'exu-phone' */
    iconLeft: {
      type: String,
      default: '',
    },
    /** CSS-класс иконки шрифта, например 'exu-close' */
    iconRight: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    inputId() {
      return `phone-input-${this.$.uid}`;
    },
  },
  watch: {
    modelValue(newVal) {
      const currentUnmasked = this.$refs.input.value.replace(/\D/g, '');
      const newUnmasked = (newVal || '').replace(/^\+/, '');
      if (currentUnmasked === newUnmasked) return;
      this.$refs.input.value = newUnmasked;
      this.$refs.input.dispatchEvent(new Event('input', { bubbles: true }));
    },
  },
  mounted() {
    if (this.modelValue) {
      this.$refs.input.value = this.modelValue.replace(/^\+/, '');
    }
  },
  methods: {
    onMaska(event) {
      const { unmasked } = event.detail;
      this.$emit('update:modelValue', unmasked ? `+${unmasked}` : '');
    },
  },
};
</script>
